import { useState } from "react";
import axios from "axios";
import { API } from "../../utils/helpers";
import { styles } from "./adminStyles";

const KullaniciTab = ({ profile, currentUserName, users, onUsersChange }) => {
  const [masterPw, setMasterPw] = useState("");
  const [newUserName, setNewUserName] = useState("");
  const [newUserProfile, setNewUserProfile] = useState("");
  const [newUserPassword, setNewUserPassword] = useState("");
  const [changePwNew, setChangePwNew] = useState("");
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const handleChangePassword = async () => {
    try {
      await axios.post(`${API}/admin/change-password`, { master_password: masterPw, profile, new_password: changePwNew });
      setSuccess("Sifre degistirildi!");
      setChangePwNew(""); setMasterPw("");
      setTimeout(() => setSuccess(""), 3000);
    } catch (err) { setError(err.response?.data?.detail || "Sifre degistirilemedi!"); setTimeout(() => setError(""), 3000); }
  };

  const handleAddUser = async () => {
    try {
      await axios.post(`${API}/admin/users`, { master_password: masterPw, profile: newUserProfile, name: newUserName, password: newUserPassword });
      setSuccess("Kullanici eklendi!");
      setNewUserName(""); setNewUserProfile(""); setNewUserPassword(""); setMasterPw("");
      onUsersChange();
      setTimeout(() => setSuccess(""), 3000);
    } catch (err) { setError(err.response?.data?.detail || "Kullanici eklenemedi!"); setTimeout(() => setError(""), 3000); }
  };

  return (
    <div style={{display: 'flex', justifyContent: 'center', padding: '30px 20px'}}>
      <div style={styles.panel}>
        <h1 style={styles.title}>Kullanici Yonetimi</h1>
        {success && <p style={styles.success}>{success}</p>}
        {error && <p style={styles.error}>{error}</p>}

        <div style={styles.section}>
          <h3 style={{ color: '#09301E', marginBottom: '10px' }}>Sifre Degistir ({currentUserName})</h3>
          <input type="password" placeholder="Yeni Sifre" value={changePwNew} onChange={(e) => setChangePwNew(e.target.value)} style={{ ...styles.input, marginBottom: '10px' }} data-testid="change-pw-new" />
          <input type="password" placeholder="Ana Parola" value={masterPw} onChange={(e) => setMasterPw(e.target.value)} style={{ ...styles.input, marginBottom: '10px' }} data-testid="master-pw-change" />
          <button onClick={handleChangePassword} style={{ ...styles.button, background: '#334155', color: '#fff' }} data-testid="change-pw-btn">Sifreyi Degistir</button>
        </div>

        <div style={{ ...styles.section, marginTop: '20px' }}>
          <h3 style={{ color: '#09301E', marginBottom: '10px' }}>Yeni Kullanici Ekle</h3>
          <input type="text" placeholder="Kullanici Adi (orn: MERKEZ)" value={newUserName} onChange={(e) => setNewUserName(e.target.value)} style={{ ...styles.input, marginBottom: '10px' }} data-testid="new-user-name" />
          <input type="text" placeholder="Profil ID (orn: 3)" value={newUserProfile} onChange={(e) => setNewUserProfile(e.target.value)} style={{ ...styles.input, marginBottom: '10px' }} data-testid="new-user-profile" />
          <input type="password" placeholder="Sifre" value={newUserPassword} onChange={(e) => setNewUserPassword(e.target.value)} style={{ ...styles.input, marginBottom: '10px' }} data-testid="new-user-password" />
          <input type="password" placeholder="Ana Parola" value={masterPw} onChange={(e) => setMasterPw(e.target.value)} style={{ ...styles.input, marginBottom: '10px' }} data-testid="master-pw-add" />
          <button onClick={handleAddUser} style={{ ...styles.button, background: '#334155', color: '#fff' }} data-testid="add-user-btn">Kullanici Ekle</button>
        </div>

        <div style={{ ...styles.section, marginTop: '20px' }}>
          <h3 style={{ color: '#09301E', marginBottom: '10px' }}>Mevcut Kullanicilar</h3>
          {users.map(u => (
            <div key={u.profile} style={{ padding: '8px 12px', borderBottom: '1px solid #ddd', display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ fontWeight: 'bold' }}>{u.name}</span>
              <span style={{ color: '#888' }}>Profil: {u.profile}</span>
            </div>
          ))}
        </div>

        <button onClick={() => window.location.href = profile === "default" ? "/" : `/${profile}`} style={{ ...styles.backButton, marginTop: '20px' }}>Fiyat Sayfasina Don</button>
      </div>
    </div>
  );
};

export default KullaniciTab;
